module.exports = __webpack_public_path__ + "img/iconfinder-icon-email.815c4833.svg";